const TableThead = ({ wpUserLoggedIn, weekNumbers }) => {
	return (
		<thead className={"text-uppercase"}>
			<tr>
				<th className={"th-week-element"}>
					Aktivitet
				</th>
				{/* // Render the table headers */}
				{weekNumbers.map((weekNumber, index) => {
					const formattedWeek = `${weekNumber}`;

					return <th key={index}>{formattedWeek}</th>;
				})}
				{wpUserLoggedIn && <th></th>}
			</tr>
		</thead>
	);
};

export default TableThead;
